import {
  createFileRoute,
  isRedirect,
  Outlet,
  redirect,
} from '@tanstack/react-router';

// relative imports
import LoadingPage from '../../../../components/shared/page-components/LoadingPage';
import {
  currentAccountIdVar,
  primaryAccountIdVar,
  switchingAccountsVar,
} from '../../../../data/apollo/cache/reactiveVars';
import { CHECK_CLIENT_ACCESS } from '../../../../data/apollo/queries';

function ClientWrapperComponent() {
  // access is gated in beforeLoad
  return <Outlet />;
}

export const Route = createFileRoute(
  '/_authenticated/client/$accountId/_clientWrapper',
)({
  component: ClientWrapperComponent,
  pendingComponent: () => <LoadingPage loadingLayout />,
  beforeLoad: async ({
    context: { apolloClient },
    params: { accountId },
    cause,
  }) => {
    const primaryAccountId = primaryAccountIdVar();
    const currentAccountId = currentAccountIdVar();

    if (!primaryAccountId) {
      throw redirect({ to: '/' });
    }

    // Only real navigations should flip switching state — prefetch (e.g. link hover)
    // must not set this or a failed prefetch can leave the app stuck loading.
    if (
      cause !== 'preload' &&
      currentAccountId &&
      currentAccountId !== accountId
    ) {
      switchingAccountsVar(true);
    }

    // Skip access check on preload: hover prefetch can hit transient HTTP issues (e.g. 307)
    // and should not redirect or corrupt the current view. Enter navigation re-runs this.
    if (cause === 'preload') {
      return;
    }

    try {
      const { data: accessData } = await apolloClient.query({
        query: CHECK_CLIENT_ACCESS,
        variables: {
          accountId: primaryAccountId,
          clientAccountId: accountId,
        },
        fetchPolicy: 'network-only',
      });

      if (!accessData?.checkClientAccessPermitted) {
        throw redirect({ to: '/' });
      }
    } catch (error) {
      if (isRedirect(error)) {
        throw error;
      }
      console.error('Error checking client access:', error);
      throw redirect({ to: '/' });
    }
  },
});